export const getEstimationItemStyle = () => ({
  itemContainer: {
    margin: '20px 0 0',
    textAlign: 'right',
    fontWeight: 'bold',

    '& .item-title': {
      lineHeight: '14px',
    },

    '& .item-dash': {
      width: '210px',
      border: '2px solid',
      margin: '8px 0 8px auto',
    },

    '& .item-estimation': {
      fontSize: '24px',
      lineHeight: '36px',
    },
  },
});

export const getDisplayPlusCampaignEstimationItemStyle = () => ({
  itemContainer: {
    margin: '20px 0 0',
    textAlign: 'left',
    fontWeight: 'bold',

    '& .item-title': {
      lineHeight: '14px',
    },

    '& .item-dash': {
      width: '302px',
      border: '2px solid',
      margin: '8px auto 8px 0',
    },

    '& .item-estimation': {
      fontSize: '24px',
      lineHeight: '36px',
    },
  },
});
